import React, { useContext } from "react";
import ReactDOM from 'react-dom/client';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import VoucherSpei from './views/VoucherSpei';
import PaypalPlus from './views/PaypalPlus';
import Saf from './views/Saf';
import reportWebVitals from './reportWebVitals';
import { Provider, useDispatch } from 'react-redux';
import { store } from './store';
import { setIdProduct, setCurrency, setPeriod,  settokenRef, setslug, setPromoCode } from './globalslice';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { AuthProvider } from "./Auth";
import { useNavigate } from 'react-router-dom';

import './lang/Configuration'
import VoucherOxxo from './views/VoucherOxxo';
import PaymentConfirm from './components/Checkout/PaymentConfirm';
import Paypal from './views/Paypal';
import Evo from './views/Evo';
import { setProfileInfo } from './slices/profileSlice';
import WhmcsApi from './services/WhmcsApi'
import { AuthContext } from "./Auth";
import ExpiredSession from "./components/Modal/ExpiredSession";
import CartCookies from "./components/CartCookies";
import LogoutWatcher from "./components/LogoutWatcher";
import { fetchValidateSession } from './helpers/apiUtils';
import SendCheckoutEventNew from './helpers/SendCheckoutEventNew';

const theme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: 'green !important'
          },
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: 'green'
            },
            '&.Mui-focused fieldset': {
              borderColor: 'green'
            }
          },
        },
      },
    },
  },
});

// Obtén el elemento raíz del DOM
const rootElement = document.getElementById('root');

// Asegúrate de que el elemento raíz exista antes de acceder a sus atributos
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  const searchParams = new URLSearchParams(window.location.search);
  const idproduct = searchParams.has('producto') ? searchParams.get('producto') : '1';
  const currency = searchParams.has('currency') ? searchParams.get('currency') : 'MXN';
  const period = searchParams.has('billingcycle') ? searchParams.get('billingcycle') : 'annually';
  const slug = searchParams.has('slug') ? searchParams.get('slug') : '';
  const tokenRef = searchParams.has('tokenRef')? searchParams.get('tokenRef') : '';
  const promoCode = searchParams.has('promocode')? searchParams.get('promocode') : '';

  const SetGlobalState = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userAuth, setUserAuth, setShowLoginExpired } = useContext(AuthContext);
    const { logout } = useContext(AuthContext);

    //Se usa esta función para resolver las urls de redirección de evo que no permite caracteres como #
    const handleRedirect = (redirect, action, invoiceId) => {
      switch (redirect) {
        case 'evo':
          switch (action) {
            case 'cancel':
              return '/checkout'; // Redirect for cancellation
            case 'timeout':
              return '/checkout'; // Redirect for timeout
            case 'confirm':
              if(invoiceId != null) {
                return `/checkout/evo/confirm/${invoiceId}?compra=exitosa`; // Redirect for confirmation
              } else {
                return '/';
              }
            default:
              return '/';
          }
      }
    };

    React.useEffect(() => {
      dispatch(setIdProduct(idproduct));
      dispatch(setCurrency(currency));
      dispatch(setPeriod(period));
      dispatch(settokenRef(tokenRef));
      dispatch(setslug(slug));
      dispatch(setPromoCode(promoCode));
    
      // Check if the 'redirect' and 'action' parameters exist
      const redirect = searchParams.get('redirect');
      const action = searchParams.get('action');
      const invoiceId = searchParams.get('invoiceid');

      // Redirecciona a otra vista si encuentra los parametros necesarios
      if (redirect && action) {
        const redirectPath = handleRedirect(redirect, action, invoiceId);
        navigate(redirectPath);
      }

      const handleLogout = () => {
        logout();
      }

      //Trae información de perfil del usuario
      const fetchProfileInfo = async () => {
        try {
          const whmcsApi = new WhmcsApi(); // Crear instancia de WhmcsApi
          const response = await whmcsApi.request("getProfileInfo", {}, "POST", userAuth.token);
          if (response.result == "error") {
            handleLogout();
          } else {
            if (response.result == "success") {
              const name = String(response.data.firstname).trim();
              const lastName = String(response.data.lastname).trim();
              const fullName = `${name} ${lastName}`;
              dispatch(
                setProfileInfo({
                  name: fullName,
                  email: response.data.email,
                  nbps: response.data.nbps.total_puntos,
                  saf: response.data.saf,
                  rfc: response.data.rfc,
                  isDealer: response.data.is_dealer,
                })
              );
              //seteamos a USD si el usuario trae el id=3
              //Por default trae setea MXN
              if(response.data.currency) {
                let currency = ""
                if (response.data.currency == "3"){
                  currency = 'USD'
                  dispatch(setCurrency(currency));
                }
              }
            }
          }
        } catch (error) {
          //Borra datos de perfil
          handleLogout();
          console.error("Failed to fetch profile:", error);
        }
      };
  
      if (!userAuth) {
          fetchValidateSession(userAuth?.token, setShowLoginExpired, setUserAuth);
      }
  
      if (userAuth) {
        fetchProfileInfo();
      }

    }, [dispatch, idproduct, currency, period, tokenRef, slug, navigate, userAuth]);

    return null;
    
  };

  // Renderizar la aplicación
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
        <AuthProvider>
            <Router>
              <ExpiredSession />
              <SetGlobalState />
              <CartCookies />
              <LogoutWatcher />
              <Routes>
                <Route path="/" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout/spei/:invoiceId" element={<VoucherSpei />} />
                <Route path="/checkout/paypalplus/:invoiceId" element={<PaypalPlus />} />
                <Route path="/checkout/paypal/:invoiceId" element={<Paypal />} />
                <Route path="/checkout/oxxo/:invoiceId?" element={<VoucherOxxo />} />
                <Route path="/checkout/evo/:invoiceId" element={<Evo />} />
                <Route path="/checkout/saf/:invoiceId" element={<Saf />} />
                <Route path="/checkout/confirm/:invoiceId" element={<PaymentConfirm confirmCost={'$0.00'} />} />

                <Route path="/checkout/cart" element={<SendCheckoutEventNew />} />
                <Route path="/checkout/cart/confirm/:invoiceId" element={<PaymentConfirm confirmCost={'$0.00'} />} />

                <Route path="*" element={<div>404 Not Found</div>} />
              </Routes>
            </Router>
          </AuthProvider>
        </Provider>
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  console.error('Root element not found');
}

// Si deseas medir el rendimiento de tu aplicación, puedes usar reportWebVitals
reportWebVitals();
